export const PLUGIN_NAMESPACE = "wordlift";
export const PLUGIN_FORMAT_NAMESPACE = "wordlift/annotate";
export const PLUGIN_META_KEY = "wl_entities_gutenberg";
export const CONVERT_CLASSIC_NOTICE_ID = "wordlift-convert-classic-editor-blocks";
